export const API_BASE_URL =
  import.meta.env.VITE_API_URL || 'http://localhost:4001'
export const AUTH_BASE_URL =
  import.meta.env.VITE_AUTH_URL || 'http://localhost:3000'
export const basePath = API_BASE_URL //+ '/v1'
